import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { toast } from 'sonner';

const useAssignCommission = () => {
  const { mutateAsync, isPending } = useMutation('assignCommission', {
    onSuccess: (res) => {
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useAssignCommission;
